import React from "react";

// Styles
import "./SubTitle.scss";

// Components
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

type SubTitleProps = {
  icon?: FontAwesomeIconProps["icon"];
  iconElement?: JSX.Element;
  text: string;
  actionText?: string;
  actionHandler?: () => void;
};

export default function SubTitle(props: SubTitleProps) {
  const { icon, text, actionText, iconElement, actionHandler } = props;

  return (
    <div className="page--admin--settings__sub-title">
      {icon && <FontAwesomeIcon icon={icon} />}
      {iconElement && iconElement}
      <h2>{text}</h2>

      {actionText && <button onClick={actionHandler}>{actionText}</button>}
    </div>
  );
}
